import {
  FieldError,
  Label,
  ToggleButtonGroup,
  ToggleButtonGroupProps,
  ValidationResult,
} from 'react-aria-components';

interface ButtonGroupProps extends ToggleButtonGroupProps {
  className?: string;
  label?: string;
  errorMessage?: string | ((validation: ValidationResult) => string);
  isRequired?: boolean;
}

export default function ButtonGroup({
  className,
  label,
  errorMessage,
  isRequired,
  children,
  ...props
}: ButtonGroupProps) {
  return (
    <div className="flex flex-col gap-1.5">
      {label && (
        <Label className="text-sm">
          {label} {isRequired && '*'}
        </Label>
      )}
      <ToggleButtonGroup {...props} className={className}>
        {children}
      </ToggleButtonGroup>
      {errorMessage && (
        <FieldError className="text-input-error text-[13px] leading-[1.7]">
          {errorMessage}
        </FieldError>
      )}
    </div>
  );
}
